import Vue from 'vue'
import VueRouter from 'vue-router'

import Start from '../components/Opq/Start.vue'
import Contact from '../components/Opq/Contact.vue'
import Finish from '../components/Opq/Finish.vue'
import Damages from '../components/Opq/Damages.vue'
import AutoOffer from '../components/Opq/AutoOffer.vue'
import Additionals from '../components/Opq/Additionals.vue'
import Opq from '../components/Opq/Index.vue'
import Widgets from '../components/Widgets.vue'
import Workshop from '../components/Workshop.vue'
import Company from '../components/Company.vue'

Vue.use(VueRouter)
//console.log(window.mpsType)
const IS_ADMIN = window.mpsType == 'admin' ? true : false;
//const IS_PARTNER = window.mpsPartnerId ? true : false;
const OPQ_SUBPATH = window.mpsType == 'admin' ? 'opq' : '' ;
let routes = [
    {
        path: '/' + OPQ_SUBPATH,
        name:'opq',
        component: Opq,
        children: [
            {
                name: 'start',
                path: IS_ADMIN ? 'start' : '',
                component: Start,
            },
            {
                name:'damage-item',
                path: 'damages/:id',
                component: Damages
            },
            {
                name:'auto-offer',
                path: 'auto-offer',
                component: AutoOffer
            },
            {
                path: IS_ADMIN ? '' : 'contact/:code?',
                name: 'contact',
                component: Contact
            },
            // {
            //     path: 'additionals',
            //     name: 'additionals',
            //     component:  Additionals
            // },
            {
                path: 'request/:type/:code/:action?',
                name:'request',
                component: Finish
            },
            {
                path: 'order/:type/:code',
                redirect: 'request/:type/:code',
            },
            {
                name: 'start-license',
                path: ':license',
                component: Start,
            }
            /*
            ,{
                name:'damage-item-bug',
                path: 'request/client/:code/damages/:id',
                component: Damages
            }
            */
        ]
    },
    {
        path: '/workshop',
        name: 'new-workshop',
        component: Workshop
    },
    {
        path: '/workshop/:id',
        name: 'workshop',
        component: Workshop
    },
    {
        path: '/company',
        name: 'new-company',
        component: Company
    },
    {
        path: '/company/:id',
        name: 'company',
        component: Company
    },

    {path: '',redirect: '/'},
    {path: '*',redirect: '/'}

    /*
    {path: '/contact', name:'contact', component: Contact},
    {path: '/finish', name:'finish', component: Finish},
    {path: '/request/:type/:code', name:'request', component: Finish},
    {
        path: '/',
        name:'start',
        component: Start,
        children: [
            {
                name: 'start-license',
                path: ':license',
                component: Start,
            },
        ],
    },
    {path: '/damages/:id',name:'damage-item',component: Damages},

    {path: '',redirect: '/'},
    {path: '*',redirect: '/'}
    */
]

if(IS_ADMIN){
    routes.unshift({
        path: '/',
        name:'widgets',
        component: Widgets
    })
}

const router = new VueRouter({
    routes: routes
});

router.afterEach(function(to, from) {
    if(from.name && to.name != from.name)
        window.$("html, body").animate({ scrollTop: window.$("#vue-request-quote-form").offset().top }, "slow");
});

export default router


// WEBPACK FOOTER //
// ./requests/assets/src/router/index.js